import React from 'react'

import { WELCOME_WIZARD_STEPS_KEY } from '../constants'
import type { ConnectedAppStatus, WizardStepKey } from '../types'
import {
  BestPracticesStep,
  BrowserExtensionStep,
  CompletionChecklistStep,
  ConfigureTrackingStep,
  DesktopAgentAccessStep,
  DesktopAgentRunningStep,
  DesktopAgentStep,
  FinishStep,
  GettingStartedStep,
  TimelineTipsStep,
  TimeEntryTipsStep,
  WelcomeCompleteStep,
} from './step'
import ManageEntriesStep from './step/ManageEntriesStep'
import ReassignMattersStep from './step/ReassignMattersStep'

export type { ConnectedAppStatus } from '../types'

type WelcomeWizardStepContentProps = {
  activeStepKey: WizardStepKey
  chromeExtensionStatus: ConnectedAppStatus
  desktopAgentStatus: ConnectedAppStatus
  edgeExtensionStatus: ConnectedAppStatus
  onSkip: () => void
}

const WelcomeWizardStepContent = ({
  activeStepKey,
  chromeExtensionStatus,
  desktopAgentStatus,
  edgeExtensionStatus,
  onSkip,
}: WelcomeWizardStepContentProps) => {
  switch (activeStepKey) {
    case WELCOME_WIZARD_STEPS_KEY.GettingStarted:
      return <GettingStartedStep />
    case WELCOME_WIZARD_STEPS_KEY.InstallDesktopAgent:
      return <DesktopAgentStep />
    case WELCOME_WIZARD_STEPS_KEY.ConfigureTracking:
      return <ConfigureTrackingStep />
    case WELCOME_WIZARD_STEPS_KEY.DesktopAgentAccess:
      return <DesktopAgentAccessStep />
    case WELCOME_WIZARD_STEPS_KEY.IdleDetection:
      return <DesktopAgentRunningStep />
    case WELCOME_WIZARD_STEPS_KEY.InstallBrowserExtension:
      return <BrowserExtensionStep />
    case WELCOME_WIZARD_STEPS_KEY.CompletionChecklist:
      return (
        <CompletionChecklistStep
          chromeExtensionStatus={chromeExtensionStatus}
          desktopAgentStatus={desktopAgentStatus}
          edgeExtensionStatus={edgeExtensionStatus}
        />
      )
    case WELCOME_WIZARD_STEPS_KEY.Finish:
      return <FinishStep />
    case WELCOME_WIZARD_STEPS_KEY.TimelinePanelTips:
      return <TimelineTipsStep onSkip={onSkip} />
    case WELCOME_WIZARD_STEPS_KEY.BestPractices:
      return <BestPracticesStep />
    case WELCOME_WIZARD_STEPS_KEY.TimeEntryPanelTips:
      return <TimeEntryTipsStep />
    case WELCOME_WIZARD_STEPS_KEY.ManageEntries:
      return <ManageEntriesStep />
    case WELCOME_WIZARD_STEPS_KEY.ReassignMatters:
      return <ReassignMattersStep />
    case WELCOME_WIZARD_STEPS_KEY.WelcomeComplete:
    default:
      return <WelcomeCompleteStep />
  }
}

export default WelcomeWizardStepContent
